export enum PermissionRequestListActionsTypes {
  GET_REQUEST = '[REQUEST] Get Request List',
  GET_REQUEST_SUCCESS = '[REQUEST] Get Request List Success',
  GET_REQUEST_ERROR = '[REQUEST] Get Request List Error',
}
